"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logDeprecatedPropCombination = exports.logDeprecatedComponent = exports.logDeprecatedPropValue = exports.logDeprecatedProp = void 0;
/* eslint-disable no-console, no-undef */
var LoggingUtils_1 = require("./LoggingUtils");
var logDeprecation = function (title, error, solution, versionStart, versionEnd) {
    var detailsMsg = error ? "%cDETAILS: %c" + error : null;
    var versionMsg = versionStart ? "%cDEPRECATED SINCE: %cv" + versionStart : null;
    var removalMsg = versionEnd ? "%cREMOVAL TARGET: %cv" + versionEnd : null;
    var solutionMsg = solution ? "%cSOLUTION: %c" + solution : null;
    LoggingUtils_1.logConsoleMessage(title, LoggingUtils_1.ConsoleMessageLevels.ERROR, detailsMsg, solutionMsg, versionMsg, removalMsg);
};
/**
 * Log a message to the browser console when a component prop is no longer needed.
 *
 * @param config Deprecation config
 */
var logDeprecatedProp = function (config) {
    if (!config) {
        throw new Error('No deprecation config provided.');
    }
    var component = config.component, propName = config.propName, seeMsg = config.seeMsg, versionEnd = config.versionEnd, versionStart = config.versionStart;
    if (propName && component) {
        var title = 'DEPRECATED PROPERTY USED';
        var error = "Prop `" + propName + "` on component `" + component + "` is deprecated and will be removed in a future release!";
        logDeprecation(title, error, seeMsg, versionStart, versionEnd);
    }
};
exports.logDeprecatedProp = logDeprecatedProp;
/**
 * Log a message to the browser console when a component prop no longer accepts a given value as valid input.
 *
 * @param config Deprecation config
 */
var logDeprecatedPropValue = function (config) {
    if (!config) {
        throw new Error('No deprecation config provided.');
    }
    var component = config.component, propName = config.propName, seeMsg = config.seeMsg, versionEnd = config.versionEnd, versionStart = config.versionStart;
    if (propName && component) {
        var title = 'DEPRECATED PROPERTY VALUE USED';
        var error = "Prop `" + propName + "` on component `" + component + "` is using a deprecated value which will be removed in a future release!";
        logDeprecation(title, error, seeMsg, versionStart, versionEnd);
    }
};
exports.logDeprecatedPropValue = logDeprecatedPropValue;
/**
 * Log a message to the browser console when a component is deprecated.
 *
 * @param config Deprecation config
 */
var logDeprecatedComponent = function (config) {
    if (!config) {
        throw new Error('No deprecation config provided.');
    }
    var component = config.component, seeMsg = config.seeMsg, versionEnd = config.versionEnd, versionStart = config.versionStart;
    if (component) {
        var title = 'DEPRECATED COMPONENT USED';
        var error = "%cComponent %c`" + component + "`%c is deprecated and will be removed in a future release!";
        logDeprecation(title, error, seeMsg, versionStart, versionEnd);
    }
};
exports.logDeprecatedComponent = logDeprecatedComponent;
var logDeprecatedPropCombination = function (config) {
    if (!config) {
        throw new Error('No deprecation config provided.');
    }
    var component = config.component, propCombination = config.propCombination, seeMsg = config.seeMsg, versionEnd = config.versionEnd, versionStart = config.versionStart;
    if (Array.isArray(propCombination) && propCombination.length > 0 && component) {
        var title = 'DEPRECATED PROPERTY COMBINATION USED';
        var error = "Combination of `" + propCombination.join(' + ') + "` props on component `" + component + "` is deprecated and may have undesired results in future releases.";
        logDeprecation(title, error, seeMsg, versionStart, versionEnd);
    }
};
exports.logDeprecatedPropCombination = logDeprecatedPropCombination;
